import styled from '@emotion/styled';
import {colors, fonts} from 'ui/config';
// import {Img, MainTitleDark as MainTitleDarkUI, HeadlineSmall} from 'ui';
import Slider from 'react-slick';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: colors.white,
  width: 320,
  padding: '16px 45px',
  marginBottom: 10,
});

export const CarouselTitle = styled('div')({
  fontFamily: fonts.title,
  fontSize: 16,
  lineHeight: '19px',
  textAlign: 'center',
  fontWeight: 'bold',
  marginBottom: 15,
});

export const Slides = styled(Slider)({
  width: '100%',
});
